import { Editable, HStack, IconButton, Text } from '@chakra-ui/react'
import { FC, useEffect, useState } from 'react'
import { LuCheck, LuPencilLine, LuX } from 'react-icons/lu'
import { DeleteButtonWithDialog } from './DeleteButtonWithDialog'
import { EventTemplateWithImplementation } from '../../models/eventTemplateWithImplementation'

interface EditableTextAreaProps {
  selectedEventTemplate: EventTemplateWithImplementation | undefined
  onSubmit: (updatedTemplate: string) => void
  deleteEventTemplate: () => void
  setIsEditingEventTemplate: (isEditing: boolean) => void
}

export const EditableTextArea: FC<EditableTextAreaProps> = ({
  selectedEventTemplate,
  onSubmit,
  deleteEventTemplate,
  setIsEditingEventTemplate,
}) => {
  const [templateValue, setTemplateValue] = useState(
    selectedEventTemplate?.template
  )

  useEffect(() => {
    setTemplateValue(selectedEventTemplate?.template ?? '')
  }, [selectedEventTemplate?.template])

  const handleOnEditChange = ({ edit }: { edit: boolean }) => {
    setIsEditingEventTemplate(edit)
  }

  if (!selectedEventTemplate) {
    return (
      <Text fontSize={'sm'} width={64} paddingX={1}>
        No Event templates found for this learning event, Create a new event
        template!
      </Text>
    )
  }

  return (
    <Editable.Root
      value={templateValue}
      position={'relative'}
      boxSize={'100%'}
      selectOnFocus={false}
      onInteractOutside={(e) => e.preventDefault()}
      onValueChange={({ value }) => setTemplateValue(value)}
      onValueCommit={() => onSubmit(templateValue ?? '')}
      activationMode='dblclick'
      onEditChange={handleOnEditChange}>
      <Editable.Preview
        padding={4}
        paddingRight={32}
        boxSize={'full'}
        bg={'defaultBackground'}
        alignItems={'flex-start'}
        overflowY={'scroll'}
      />
      <Editable.Textarea
        _focus={{
          outline: '1px solid #333;',
        }}
        padding={4}
        paddingRight={32}
        boxSize={'full'}
        resize={'none'}
        bg={'defaultBackground'}
        placeholder='Statement template...'
      />
      <HStack position={'absolute'} padding={4} top={0} right={0}>
        <Editable.Control>
          <Editable.EditTrigger asChild>
            <IconButton variant='ghost' size='xs'>
              <LuPencilLine />
            </IconButton>
          </Editable.EditTrigger>
          <Editable.CancelTrigger asChild>
            <IconButton variant='outline' size='xs'>
              <LuX />
            </IconButton>
          </Editable.CancelTrigger>
          <Editable.SubmitTrigger asChild>
            <IconButton variant='outline' size='xs'>
              <LuCheck />
            </IconButton>
          </Editable.SubmitTrigger>
        </Editable.Control>
        <DeleteButtonWithDialog
          onDelete={deleteEventTemplate}
          deletedObjectName={`${selectedEventTemplate?.companyName} - ${selectedEventTemplate?.implementationName}`}
          buttonProps={{ size: 'xs' }}
        />
      </HStack>
    </Editable.Root>
  )
}
